import { Button } from 'antd';
import { imgBgBannerLoginMobile, imgFamily } from 'assets/images';
import { RoutesV1 } from 'constants/appRoutes';
import useDevice from 'hooks/useDevice';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import styled from 'styled-components';
import { iconStarr } from 'assets/icons';

const SlideStyled = styled(Slider)`
  .slick-dots {
    li {
      height: 4px;
      width: 12px;
      opacity: 0.3;
      background-color: #ffffff;
      &.slick-active {
        opacity: 0.8;
      }

      button:before {
        content: '';
        line-height: 0;
      }
    }
  }
`;

export default function SlideLogin() {
  const [slides, setSlides] = useState([]);
  const { isMobile } = useDevice();

  useEffect(() => {
    if (isMobile) {
      setSlides([<SlideItemMobile />, <SlideItemMobile />, <SlideItemMobile />]);
    } else {
      setSlides([<SlideItem />, <SlideItem />, <SlideItem />]);
    }
    return () => {};
  }, [isMobile]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    dotsClass: 'slick-dots',
    autoplaySpeed: 4000,
    // autoplay: true,
  };

  return (
    <div className='mb-30px mt-20px w-full md:my-0 md:w-484px'>
      <SlideStyled {...settings}>
        {slides.map((item, index) => {
          return <div key={index}>{item}</div>;
        })}
      </SlideStyled>
    </div>
  );
}

const SlideItemMobile = ({ onClick }) => {
  return (
    <div className='h-150px px-24px' onClick={onClick}>
      <div className='overflow-hidden rounded-10px'>
        <img src={imgBgBannerLoginMobile} alt='' className='h-full w-full object-cover' />
      </div>
    </div>
  );
};

const SlideItem = () => {
  const navigate = useNavigate();
  return (
    <div className='text-white'>
      <img src={imgFamily} alt='' width={376} />
      <p className='mb-5px mt-4px font-averta-bold text-20px leading-25px'>
        Bảo hiểm Ung thư và Đột quỵ
      </p>
      <div className='mb-17px text-14px leading-20px'>
        <div className='flex items-start gap-5px'>
          <img src={iconStarr} alt='' width={14} />
          <p>Bảo hiểm online có Quyền lợi ung thư CAO NHẤT trên thị trường</p>
        </div>
        <div className='flex items-start gap-5px'>
          <img src={iconStarr} alt='' width={14} />
          <p>Bảo hiểm DUY NHẤT có tầm soát ung thư cho người thân</p>
        </div>
        <div className='flex items-start gap-5px'>
          <img src={iconStarr} alt='' width={14} />
          <p>Bảo hiểm online DUY NHẤT có tích hợp cả Quyền lợi UNG THƯ & ĐỘT QUỴ</p>
        </div>
      </div>

      <Button
        onClick={() => {
          navigate(RoutesV1.insuranceOnline);
        }}
        className='h-28px rounded-4px border border-white bg-white bg-opacity-10 px-52px'
      >
        <span className='text-14px uppercase leading-20px text-white'>Mua ngay</span>
      </Button>
    </div>
  );
};
